if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
      this.algoliaClient = null;
      this.query = "";
    }
    
    connectedCallback() {
      poll(() => {
        return window.algoliasearch;
      }, 10000, 150).then(() => {
        this.init();
      })
      
      this.addEventListener('click', (e) => {
        if (e.target.closest('[href]')) {
          const value = e.target.closest('[data-object-id]')?.querySelector('[data-product-title]')?.innerText.trim() || e.target.innerText.trim();
          window.localStorage.setItem(`clicked_predictive_search_suggestion`, value);
          window.localStorage.setItem(`redirect_query_predictive_search`, this.query);
        }
      });
      
      this.addEventListener('submit', () => {
        window.localStorage.setItem(`predictive_search_used`, true);
      });
      
      document.addEventListener('click', e => {
        if (!e.target.closest('predictive-search') && this.isOpen) {
          this.close();
          return;
        }
        
        const clickedElement = e.target.closest('[data-predictive-search-action]');
        if (!clickedElement) return;
        if (!this.query) e.preventDefault();
        
        const {
          predictiveSearchAction: action,
        } = clickedElement.dataset;
                
        switch (action) {
          case 'close':
            this.close();
          break;
          case 'open':
            this.open();
          break;
          case 'submit':
            this.querySelector('form')?.submit();
          break;
          default:
          break;
        }
      });
    }
    
    init() {
      this.algoliaClient = window.algoliasearch(algoliaAppId, algoliaAPI);
      this.algoliaClient.initIndex(`shopify_products`);
      this.locale = this.dataset.locale == 'false' ? false : this.dataset.locale  
    }
    
    close() {
      this.classList.remove('open');
      document.body.classList.remove('overlay', 'nav-open');
      this.isOpen = false;
      this.removeEventListener('keydown', this.onKeyUp)
    }
    
    open() {
      this.classList.add('open');
      document.body.classList.add('overlay', 'nav-open');
      this.isOpen = true;
      this.addEventListener('keyup', this.onKeyUp);
      this.trapFocus();
      this.getTrendingCategories();
    }
    
    onKeyUp(e) {
      if (e.key === `Escape`) {
        this.close();
        return;
      }
      if (e.key !== `Tab`) {
        this.query = e.target.value;
        this.querySelectorAll('[data-query]').forEach(x => x.innerText = this.query);
        this.fetchResults().then(({ products, collections }) => {
          this.renderProductResults(products);
          this.renderCollectionResults(collections);
          this.querySelector('[data-assertive-text]').innerHTML = `${products.length} results found` 
        });
        
      }
    }

    trapFocus() {
      const focusableElements = this.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
      this.firstFocusableEl = focusableElements[0];  
      this.lastFocusableEl = focusableElements[focusableElements.length - 1];
      this.firstFocusableEl?.focus();
      this.addEventListener('keydown', (e) => this.focusListener(e));
    }

    focusListener(e) {
      if (e.key === 'Tab' || e.keyCode === 9) {
        if (e.shiftKey ) /* shift + tab */ {
          if (e.target === this.firstFocusableEl) {
            this.querySelector('[data-predictive-search-action="close"]').focus();
            e.preventDefault();
          }
        } else /* tab */ {
          if (e.target === this.lastFocusableEl) {
            this.querySelector('[data-predictive-search-action="close"]').focus();
            e.preventDefault();
          }
        }
      }
    }
    
    getTrendingCategories() {
      
      window.recommendClient.getTrendingFacets([
        {
          indexName: 'shopify_products',
          threshold: 80,
          facetName: '_tags'
        },
      ])
      .then(({ results }) => {
        if (!results[0]?.hits.length) {
          throw('No recommendations'); 
        }
        // todo: build out recommend here once it starts working 
      })
      .catch(err => {
        console.error(`Predictive search: `, err);
        // this.fetchResults().then(({ collections }) => {
        //   this.renderTrendingCategories(collections)
        // })
      });
    }
    
    // renderTrendingCategories(hits) {
    //   if (!hits.length) {
    //     return;
    //   }
      
    //   const trendingWrapper = this.querySelector('[data-popular-categories]');
    //   trendingWrapper.innerHTML = ``;

    //   hits.forEach(collection => {
    //     trendingWrapper.insertAdjacentHTML(
    //       'beforeend',
    //       `<li><intersection-loader 
    //         data-url="${this.locale ? `/${this.locale}` : `` }/collections/${collection.handle}"
    //         data-section-id="category-tile"
    //         data-extra="position:${collection.position},object-id:${collection.objectID}"
    //       >
    //         <div class="flex flex-col items-center gap-3 w-full">
    //           <div class="aspect-[2/3] bg-dustyGray animate-pulse opacity-20 w-full"></div>
    //           <div class="h-3 w-1/2 bg-dustyGray animate-pulse opacity-20"></div>      
    //         </div>
    //       </intersection-loader></li>
    //       `
    //     )
    //   });
    // }
    
    renderCollectionResults(hits) {
      if (!hits.length || !this.query) {
        this.classList.toggle('has-suggestions', false);
        return;
      }
      
      this.classList.toggle('has-suggestions', true);
      const suggestionResultsWrapper = this.querySelector('[data-suggestions]');
      suggestionResultsWrapper.innerHTML = ``;
      hits.forEach(collection => {
        suggestionResultsWrapper.insertAdjacentHTML(
          'beforeend',
          `<li>
            <a 
              class="h-11 px-4 flex items-center justify-center text-center text-sm border border-current text-secondaryDark hover:bg-secondaryDark hover:text-primaryLight transition duration-200 no-underline capitalize"
              href="/collections/${collection.handle}"
              data-object-id="${collection.objectID}"
            >
              ${collection.title}
            </a>
          </li>`
        )
      });
    }
    
    renderProductResults(hits) {
      if (!hits.length || !this.query) {
        this.classList.toggle('has-results', false);
        return;
      }
      
      this.classList.toggle('has-results', true);
      const productResultsWrapper = this.querySelector('[data-product-results]');
      productResultsWrapper.innerHTML = ``;
      hits.forEach(product => {
        productResultsWrapper.insertAdjacentHTML( // intersection-loader from intersection-loader.js
          'beforeend',
          `<intersection-loader 
            data-url="${this.locale ? `/${this.locale}` : `` }/products/${product.handle}" 
            data-section-id="product-tile"
            data-extra="position:${product.position},object-id:${product.objectID}"
          >
            <div class="flex flex-col gap-6 w-full">
              <div class="aspect-[2/3] bg-dustyGray animate-pulse opacity-20"></div>
              <div class="h-6 w-3/4 bg-dustyGray animate-pulse opacity-20"></div>
              <div class="h-5 w-20 bg-dustyGray animate-pulse opacity-20"></div>
              <div class="grid grid-cols-6 gap-1">
                <div class="aspect-[40.5/18] bg-dustyGray animate-pulse opacity-20"></div>
                <div class="aspect-[40.5/18] bg-dustyGray animate-pulse opacity-20"></div>
                <div class="aspect-[40.5/18] bg-dustyGray animate-pulse opacity-20"></div>
                <div class="aspect-[40.5/18] bg-dustyGray animate-pulse opacity-20"></div>
              </div>
            </div>
          </intersection-loader>`
        )
      });
    }
    
    async fetchResults() {
      return await this.algoliaClient.multipleQueries([{
        indexName: `shopify_products_best_selling`,
        clickAnalytics: true,
        filters: `NOT tags:base-product AND NOT tags:hide-product`,
        params: {
          hitsPerPage: 4,
          page: 0,
          query: this.query,
          ruleContexts: `predictive-search`
        }
      },{
        indexName: `shopify_collections`,
        clickAnalytics: true,
        params: {
          hitsPerPage: 5,
          page: 0,
          query: this.query,
          ruleContexts: `predictive-search`
        }
      }], 1, false).then((res) => {
        window.dispatchEvent(new CustomEvent('algolia:setData', { 
          detail: { 
            queryID: res.results[0]?.queryID,
            index: `shopify_products_best_selling`
          } 
        }));
        window.dispatchEvent(new CustomEvent('algolia:productsViewed', { 
          detail: { 
            products: res.results[0]?.hits, 
          } 
        }));
        
        return { 
          products: res.results[0]?.hits, 
          collections: res.results[1]?.hits
        }
      });
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
}